import React from "react";
import Email from "../assets/images/Email.png";
import Whatsaap from "../assets/images/Whatsaap.png";

const ContactButton = (props) => {
  const {handleMail,handleWhatsapp} = props;
  return (
    <div className="contact-button-container">
      <div className="contact-button" onClick={handleMail}>
        <img src={Email} className="contact-icon" alt="Email" />
        <span className="contact-text">Mail us</span>
      </div>
      <div className="contact-button" onClick={handleWhatsapp}>
        <img src={Whatsaap} className="contact-icon" alt="WhatsApp" />
        <span className="contact-text">WhatsApp chat</span>
      </div>
    </div>
  );
};

export default ContactButton;
